module.exports = __webpack_public_path__ + "img/bv.e6fd0d83.png";